import { forwardRef } from "react";
import { PatternFormat, PatternFormatProps } from "react-number-format";

import { cn } from "src/core/lib/utils";

type MaskedInputProps = Omit<PatternFormatProps, "format"> & {
  mask?: string;
};

export const MaskedInput = forwardRef<HTMLInputElement, MaskedInputProps>(
  ({ className, mask = "##/##/####", ...props }, ref) => {
    return (
      <PatternFormat
        {...props}
        format={mask}
        getInputRef={ref}
        placeholder="JJ/MM/AAAA"
        className={cn("", props.disabled && "cursor-not-allowed", className)}
      />
    );
  }
);

MaskedInput.displayName = "MaskedInput";
